import styled from 'styled-components'

export const ScrollableContent = styled.div({
  overflowY: 'auto',
})
